<h2>The list:</h2>
<mat-nav-list>
  @for (todo of todos$ | async; track todo) {
    <a mat-list-item [routerLink]="`/todos/${todo.id}`">{{ todo.title }}</a>
  }
</mat-nav-list>
<button mat-fab aria-label="Example icon button with a delete icon" [routerLink]="['/todos/create']">
  <mat-icon>add</mat-icon>
</button>